module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No project like this can be accomplished through the efforts of the authors alone, and we would like to acknowledge the valuable assistance of John Beekman of the Jersey City Free Public Library, Ed Civinskas, New Jersey State Police archivist Mark Falzini, Ernie Giudci, Dan Lane, Sergeant First Class (ret.) Duncan MacQueen, Robert Perricelli and Fred Carl of InfoAge Museum, Cory Newman, Robert Rudinski, New Jersey National Guard Militia Museum curator Captain Vincent Solomeno and Steve Southwick. Our thanks are due to all, as are our apologies to anyone we inadvertently missed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26d5baf3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgement.vue
// module id = 75
// module chunks = 0